// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Word$Phonics = require("./Word.bs.js");
var Storage$Phonics = require("./Storage.bs.js");

function SavedWords(Props) {
  var onWordClicked = Props.onWordClicked;
  var onCloseClicked = Props.onCloseClicked;
  var match = React.useState((function () {
          return /* [] */0;
        }));
  var setSavedWords = match[1];
  React.useEffect((function () {
          Curry._1(setSavedWords, (function (param) {
                  return Storage$Phonics.loadWords(/* () */0);
                }));
          return ;
        }), []);
  return React.createElement("div", {
              className: "saved-words"
            }, $$Array.of_list(List.map((function (word) {
                        return React.createElement(Word$Phonics.make, {
                                    word: word,
                                    onDeleteClicked: (function (param) {
                                        var word$1 = word;
                                        var words = Storage$Phonics.deleteWord(word$1);
                                        console.log(Storage$Phonics.toString(words));
                                        return Curry._1(setSavedWords, (function (param) {
                                                      return words;
                                                    }));
                                      }),
                                    onClick: (function (param) {
                                        return Curry._1(onWordClicked, word);
                                      }),
                                    key: Word$Phonics.toString(word)
                                  });
                      }), match[0])), React.createElement("button", {
                  className: "transparent-button close-button",
                  title: "Close",
                  onClick: (function (_evt) {
                      return Curry._1(onCloseClicked, /* () */0);
                    })
                }));
}

var make = SavedWords;

exports.make = make;
/* react Not a pure module */
